<script lang="ts">
	import FieldLoading from './FieldLoading.svelte';
</script>

<div class="grid grid-cols-1 pt-4 md:grid-cols-4 md:gap-x-8 md:px-4">
	<FieldLoading />
	<FieldLoading />
	<FieldLoading />
	<FieldLoading />
</div>
